function basicEmptyCheck(value) {
  return typeof value === 'undefined' || value === null;
}

export default basicEmptyCheck;